import { Controller } from '@hotwired/stimulus'
import BarReviewCourseProgressChannel from 'channels/bar_review/course_progress_channel'
import Chartkick from "chartkick"
import "chartkick/chart.js"

export default class extends Controller {
  static values = {
    scheduleId: String,
    updateNeeded: Boolean,
    chartId: String
  }

  static targets = ["status"]
  initialize() {
    if (this.updateNeededValue) {
      this.channel = new BarReviewCourseProgressChannel(this.scheduleIdValue, this.statusTarget, this.chartIdValue)
      this.channel.start()
    }
  }

  connect() {
    this.addCustomTooltip()
    this.addVerticalLine()
  }

  // create a custom tooltip label that shows completed % and number of tasks
  // use Javascript since JS callback functions cannot be passed through Chartkick configuration
  addCustomTooltip() {
    const chart = Chartkick.charts[this.chartIdValue]
    if (chart) {
      const chartOptions = chart.getOptions()
      const controller = this
      const tooltipCallback = {
        label: function (context) {
          const tooltipData = chart.data[context.datasetIndex].tooltipData[context.dataIndex]
          const label = controller.createLabel(context, tooltipData)
          return label
        }
      }
      chartOptions.library.plugins.tooltip.callbacks = tooltipCallback
      chart.setOptions(chartOptions)
    }
  }

  createLabel(context, tooltipData) {
    const lableWidth = 40
    const extraWidth = 7
    let label = context.dataset.label
    const body = `${context.formattedValue}% (${tooltipData[0]} tasks)`
    let spaceNeeded = lableWidth - label.length - body.length
    if (context.datasetIndex === 1) {
      spaceNeeded += extraWidth
    }
    const spacing = " ".repeat(spaceNeeded)
    label += `:${spacing}${body}`
    return label
  }

  addVerticalLine() {
    const verticalLinePlugin = {
      id: 'verticalLineOnHover',
      beforeDraw: (chart) => {
        if (chart.tooltip._active && chart.tooltip._active.length) {
          const activePoint = chart.tooltip._active[0]
          const ctx = chart.ctx
          const x = activePoint.element.x
          const topY = chart.scales.y.bottom
          const bottomY = chart.scales.y.top

          ctx.save()
          ctx.beginPath()
          ctx.moveTo(x, topY)
          ctx.lineTo(x, bottomY)
          ctx.lineWidth = 2
          ctx.strokeStyle = '#ACACAC'
          ctx.stroke()
          ctx.restore()
        }
      }
    }

    if (Chart) {
      Chart.register(verticalLinePlugin)
    }
  }
}
